import React from 'react'
import {Shield} from 'lucide-react'

interface FooterProps {
  onAdminClick?: () => void
  onHowItWorksClick?: () => void
  onTermsClick?: () => void
  onPrivacyClick?: () => void
}

export function Footer({ onAdminClick, onHowItWorksClick, onTermsClick, onPrivacyClick }: FooterProps) {
  return (
    <footer className="border-t border-white/10 py-12 px-4 sm:px-6 lg:px-8 mt-20 bg-gradient-to-b from-[#0A0E27] via-[#0d1339] to-[#0A0E27]">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col items-center gap-6">
          <div className="flex gap-6">
            {onTermsClick && (
              <button
                onClick={onTermsClick}
                className="text-gray-400 hover:text-white transition-colors"
              >
                Terms
              </button>
            )}
            {onPrivacyClick && (
              <button
                onClick={onPrivacyClick}
                className="text-gray-400 hover:text-white transition-colors"
              >
                Privacy
              </button>
            )}
            {onHowItWorksClick && (
              <button
                onClick={onHowItWorksClick}
                className="text-gray-400 hover:text-white transition-colors"
              >
                How it Works
              </button>
            )}
            <a 
              href="https://t.me/chumponbase" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white transition-colors"
            >
              Contact
            </a>
            {onAdminClick && (
              <button
                onClick={onAdminClick}
                className="text-gray-400 hover:text-white transition-colors flex items-center gap-1"
              >
                <Shield className="w-3 h-3" />
                Admin
              </button>
            )}
          </div>
          <div className="flex items-center gap-2">
            <img 
              src="https://static.lumi.new/e3/e39f2b464939bf84da8bfe117fca0e35.webp" 
              alt="Base Builders Logo" 
              className="w-8 h-8 rounded-lg object-cover"
            />
            <span className="text-gray-400">© 2026 Base Builders. All rights reserved.</span>
          </div>
        </div>
      </div>
    </footer>
  )
}
